import script from "./WeeklyView.vue?vue&type=script&setup=true&lang=js"
export * from "./WeeklyView.vue?vue&type=script&setup=true&lang=js"

import "./WeeklyView.vue?vue&type=style&index=0&id=4515b7f3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4515b7f3"]])

export default __exports__